
<div #metricbyscore id="metricbyscore"></div>
<div #metricbyscoreXaxis id="metricbyscoreXaxis"></div>


